import { Grid } from '@mui/material';
import styled from 'styled-components';

export const FullPageContainer = styled(({ ...props }) => <Grid container direction="column" {...props} />)`
  height: 100%;
  flex-wrap: nowrap !important;
`;
